import {
  SUPPORT_ARTICLE_QUICK_TOUR_ROUTE,
  SUPPORT_ARTICLE_SHOP_WITH_CREDITS_ROUTE,
  SUPPORT_ARTICLE_FIRST_DELIVERY_ROUTE,
  SUPPORT_ARTICLE_FOOD_PROFILE_ROUTE,
  SUPPORT_ARTICLE_SCHEDULE_MANAGEMENT_ROUTE,
  SUPPORT_ARTICLE_DELIVERY_ISSUES_ROUTE,
  SUPPORT_ARTICLE_EDIT_ORDER_ROUTE,
  SUPPORT_ARTICLE_EDIT_PLAN_ROUTE,
  ORDER_ROUTE,
  PLAN_ROUTE,
  WALLET_ROUTE,
  MY_HUNGRYROOT_ROUTE,
  ORDER_DETAILS_ROUTE,
  HOMEPAGE_ROUTE,
  REVIEWS_ROUTE,
  LEADERSHIP_ROUTE,
  PHILOSOPHY_ROUTE,
  PACKAGING_ROUTE,
  TERMS_ROUTE,
  ACCESSIBILITY_ROUTE,
  PRIVACY_ROUTE,
  CA_EMPLOYEE_PRIVACY_POLICY_ROUTE,
  GIFT_ROUTE,
  GIFT_SUBMIT_CLAIM_CODE_ROUTE,
  CAREERS_ROUTE,
  ROUTE_SIGN_UP_INTRO,
  PRE_AUTH_CATALOG_GROCERIES_ROUTE,
  PRE_AUTH_CATALOG_RECIPES_ROUTE,
  PRE_AUTH_CATALOG_MEALS_ROUTE,
  DISCOVER_RECIPES_ROUTE,
  DISCOVER_MEALS_ROUTE,
  DISCOVER_BROWSE_GROCERIES_ROUTE,
  DISCOVER_GROCERIES_ROUTE,
  DISCOVER_COOKBOOKS_ROUTE,
  DISCOVER_ROUTE,
  COOKBOOK_ROUTE,
  COOKBOOK_LANDING_PAGE_ROUTE,
  COMMUNITY_COOKBOOK_ROUTE,
  HOW_IT_WORKS_ROUTE,
  QUESTIONS_ROUTE,
  BROWSE_ROUTE,
  MY_COOKBOOK_ROUTE,
  CHECKOUT_SHIPPING_ROUTE,
  CHECKOUT_CONGRATS_ROUTE,
  CHECKOUT_PAYMENT_ROUTE,
  CYO_ROUTE,
  DISCOVER_FEED_ROUTE,
  GUEST_ACCOUNT_SETTINGS_ROUTE,
  GUEST_FOOD_PROFILE_DIETARY_PREFERENCES_ROUTE,
  GUEST_MY_COOKBOOK_DETAIL_ROUTE,
  GUEST_MY_COOKBOOK_FAVORITES_ROUTE,
  GUEST_MY_COOKBOOK_ROUTE,
  PRECHECKOUT_PLAN_ROUTE,
  START_MY_COOKBOOK_ROUTE,
  START_ORDER_ROUTE,
  ROUTE_MINI_QUIZ_AVOIDANCES,
  ROUTE_MINI_QUIZ_BUDGET,
  ROUTE_MINI_QUIZ_BUDGET_BENEFITS,
  ROUTE_MINI_QUIZ_CUISINES,
  ROUTE_MINI_QUIZ_DISH_TYPES,
  ROUTE_MINI_QUIZ_EATING_HABITS,
  ROUTE_MINI_QUIZ_FOOD_FORMATS,
  ROUTE_MINI_QUIZ_FOOD_PREFERENCES_INTRO,
  ROUTE_MINI_QUIZ_HELLO,
  ROUTE_MINI_QUIZ_INDEX,
  ROUTE_MINI_QUIZ_LOADING,
  ROUTE_MINI_QUIZ_MACRO_NUTRIENT,
  ROUTE_MINI_QUIZ_MACRO_NUTRIENT_LOW_SODIUM,
  ROUTE_MINI_QUIZ_MEAL_FREQUENCIES,
  ROUTE_MINI_QUIZ_PROTEIN,
  ROUTE_MINI_QUIZ_SIGNUP,
  ROUTE_MINI_QUIZ_SWIPE,
  ROUTE_MINI_QUIZ_TERMINAL,
} from '@hungryroot/routes';

export const RECIPE_PAGE_NAME_MAPPINGS = {
  is_breakfast: 'breakfast',
  is_lunch: 'lunch',
  is_kids_meals: 'kids_meals',
  is_family_meals: 'family_meals',
  is_tacos: 'tacos',
  is_stir_fries: 'stir_fries',
  is_bakes: 'bakes',
  is_pastas: 'pastas',
  is_pizza: 'pizza',
  is_main_sides: 'main_sides',
  is_burgers: 'burgers',
  is_bowls: 'bowls',
  is_salads: 'salads',
  is_sandwiches: 'sandwiches',
  is_soups_stews: 'soups_stews',
  is_wraps: 'wraps',
  is_starters_and_sides: 'starters_sides',
};

export const GROCERIES_PAGE_NAME_MAPPINGS = {
  is_supplements: 'supplements',
  is_ready_to_eat: 'meals',
  is_kids: 'kids',
  is_produce: 'produce',
  is_sauces_condiments: 'sauces_condiments',
  is_meat_seafood: 'meat_seafood',
  is_plant_proteins: 'plant_based_proteins',
  is_grains_pastas: 'grains_pastas',
  is_bread_bakery: 'bread_bakery',
  is_cereal_oats: 'cereal_oats',
  is_snacks: 'snacks',
  is_sweets: 'sweets',
  is_dairy_eggs: 'dairy_eggs',
  is_pantry: 'pantry',
  is_beverages: 'drinks',
  is_sides: 'sides',
};

export const PATH_PAGE_NAME_MAPPINGS = {
  [HOMEPAGE_ROUTE]: 'homepage',
  [MY_HUNGRYROOT_ROUTE]: 'home',
  [ORDER_ROUTE]: 'order_details',
  [ORDER_DETAILS_ROUTE]: 'order_details',
  [PLAN_ROUTE]: 'plan',
  [WALLET_ROUTE]: 'wallet',
  [SUPPORT_ARTICLE_QUICK_TOUR_ROUTE]: 'support_article_quick_tour',
  [SUPPORT_ARTICLE_SHOP_WITH_CREDITS_ROUTE]:
    'support_article_shop_with_credits',
  [SUPPORT_ARTICLE_FIRST_DELIVERY_ROUTE]: 'support_article_first_delivery',
  [SUPPORT_ARTICLE_FOOD_PROFILE_ROUTE]: 'support_article_food_profile',
  [SUPPORT_ARTICLE_SCHEDULE_MANAGEMENT_ROUTE]:
    'support_article_schedule_management',
  [SUPPORT_ARTICLE_DELIVERY_ISSUES_ROUTE]: 'support_article_delivery_issues',
  [SUPPORT_ARTICLE_EDIT_ORDER_ROUTE]: 'support_article_edit_order',
  [SUPPORT_ARTICLE_EDIT_PLAN_ROUTE]: 'support_article_edit_plan',
  [REVIEWS_ROUTE]: 'reviews',
  [LEADERSHIP_ROUTE]: 'leadership',
  [PHILOSOPHY_ROUTE]: 'philosophy',
  [PACKAGING_ROUTE]: 'packaging',
  [TERMS_ROUTE]: 'terms',
  [ACCESSIBILITY_ROUTE]: 'accessibility',
  [PRIVACY_ROUTE]: 'privacy',
  [CA_EMPLOYEE_PRIVACY_POLICY_ROUTE]: 'privacy_ca_employee_notice',
  [GIFT_ROUTE]: 'gift',
  [GIFT_SUBMIT_CLAIM_CODE_ROUTE]: 'gift_submit_claim_code',
  [CAREERS_ROUTE]: 'careers',
  [ROUTE_SIGN_UP_INTRO]: 'signup',
  [PRE_AUTH_CATALOG_GROCERIES_ROUTE]: 'catalog_groceries',
  [PRE_AUTH_CATALOG_RECIPES_ROUTE]: 'catalog_recipes',
  [PRE_AUTH_CATALOG_MEALS_ROUTE]: 'catalog_meals',
  [DISCOVER_ROUTE]: 'discover_recipes_and_cookbooks',
  [DISCOVER_RECIPES_ROUTE]: 'discover_recipes',
  [DISCOVER_MEALS_ROUTE]: 'discover_meals',
  [DISCOVER_BROWSE_GROCERIES_ROUTE]: 'discover_browse_groceries',
  [DISCOVER_GROCERIES_ROUTE]: 'discover_groceries',
  [DISCOVER_COOKBOOKS_ROUTE]: 'discover_cookbooks',
  [COOKBOOK_ROUTE]: 'cookbook',
  // The paid-traffic landing page gets its own name rather than reusing
  // 'cookbook': it is a distinct acquisition surface, and collapsing it into the
  // detail pages would make its ad performance unreadable.
  [COOKBOOK_LANDING_PAGE_ROUTE]: 'cookbook_landing_page',
  // Public community (user-generated) cookbook reuses the existing 'cookbook'
  // page name so analytics treat both detail surfaces as one page.
  [COMMUNITY_COOKBOOK_ROUTE]: 'cookbook',
  [HOW_IT_WORKS_ROUTE]: 'how_it_works',
  // Named here so `buttonClickedEvent` on the FAQ page reports a page name
  // instead of null — the hamburger "Get started" click is one of those.
  [QUESTIONS_ROUTE]: 'questions',
  // Exp 242 (Popsicle Nav/IA) mobile tabs are their own routes: the search tab
  // (/browse/) and the cookbook tab (/mycookbook/). Map them so pairing/product
  // interactions report a dynamic page_name here instead of falling through to a
  // stale/absent value. The cookbook tab reuses 'cookbook' like the detail
  // surfaces above.
  [BROWSE_ROUTE]: 'search',
  [MY_COOKBOOK_ROUTE]: 'cookbook',
  [ROUTE_MINI_QUIZ_INDEX]: 'mini_quiz',
  // Exp 255 freemium pre-auth surfaces. Every `Button Clicked` on these routes
  // derived `page_name: null` until they were listed here — the same defect that
  // shipped once already on the mini quiz, which is what the route-coverage guard
  // in `getPathPageName.spec.ts` now exists to catch.
  //
  // ORDER IS LOAD-BEARING for the two guest-cookbook entries below.
  // `getPathPageName` returns the FIRST `matchPath(..., { exact: true })` hit, and
  // `GUEST_MY_COOKBOOK_DETAIL_ROUTE` is `/guest/mycookbook/:cookbookId/` — whose
  // param happily matches the literal segment `favorites`. Favorites must come
  // first or it silently reports the detail page's name.
  [DISCOVER_FEED_ROUTE]: 'discover_feed_unpersonalized',
  [GUEST_MY_COOKBOOK_FAVORITES_ROUTE]: 'guest_cookbook_favorites',
  [GUEST_MY_COOKBOOK_ROUTE]: 'guest_cookbook',
  [GUEST_MY_COOKBOOK_DETAIL_ROUTE]: 'guest_cookbook_detail',
  // `my_cookbook_intro` belongs to the PROSPECT splash at `/start-mycookbook/`,
  // not to the guest's actual cookbook — spec rows 15-18 describe this page
  // (it is the one carrying the "Get recipes picked for you" hero CTA, see
  // `MyCookbookIsland`). An earlier pass had these two the wrong way round.
  [START_MY_COOKBOOK_ROUTE]: 'my_cookbook_intro',
  [START_ORDER_ROUTE]: 'start_order',
  [GUEST_FOOD_PROFILE_DIETARY_PREFERENCES_ROUTE]: 'guest_dietary_preferences',
  [GUEST_ACCOUNT_SETTINGS_ROUTE]: 'guest_account_settings',
  // Shared first-order checkout, reached by every arm. `CHECKOUT_SHIPPING_ROUTE`
  // was already mapped by the mini quiz work; these complete the run so a future
  // `Button Clicked` on any checkout step reports a name.
  [CYO_ROUTE]: 'choose_your_gift',
  [PRECHECKOUT_PLAN_ROUTE]: 'survey_plan',
  [CHECKOUT_PAYMENT_ROUTE]: 'checkout_payment',
  [CHECKOUT_CONGRATS_ROUTE]: 'checkout_congrats',
  [ROUTE_MINI_QUIZ_FOOD_FORMATS]: 'mini_quiz_food_formats',
  [ROUTE_MINI_QUIZ_DISH_TYPES]: 'mini_quiz_dish_types',
  [ROUTE_MINI_QUIZ_MACRO_NUTRIENT]: 'mini_quiz_macro_nutrient',
  [ROUTE_MINI_QUIZ_MACRO_NUTRIENT_LOW_SODIUM]:
    'mini_quiz_macro_nutrient_low_sodium',
  [ROUTE_MINI_QUIZ_EATING_HABITS]: 'mini_quiz_eating_habits',
  [ROUTE_MINI_QUIZ_CUISINES]: 'mini_quiz_cuisines',
  [ROUTE_MINI_QUIZ_PROTEIN]: 'mini_quiz_protein',
  [ROUTE_MINI_QUIZ_AVOIDANCES]: 'mini_quiz_avoidances',
  [ROUTE_MINI_QUIZ_LOADING]: 'mini_quiz_loading',
  [ROUTE_MINI_QUIZ_SIGNUP]: 'mini_quiz_signup',
  [ROUTE_MINI_QUIZ_HELLO]: 'mini_quiz_hello',
  [ROUTE_MINI_QUIZ_FOOD_PREFERENCES_INTRO]: 'mini_quiz_food_preferences_intro',
  [ROUTE_MINI_QUIZ_SWIPE]: 'mini_quiz_swipe',
  [ROUTE_MINI_QUIZ_TERMINAL]: 'mini_quiz_terminal',
  // The post-signup tail (Exp 255 rows 56-60). Both variants share these
  // three screens, and they sit on their own `/mini-quiz/` paths rather than
  // the full funnel's `/quiz/` equivalents — so they need their own entries.
  [ROUTE_MINI_QUIZ_MEAL_FREQUENCIES]: 'mini_quiz_meal_frequencies',
  [ROUTE_MINI_QUIZ_BUDGET]: 'mini_quiz_budget',
  [ROUTE_MINI_QUIZ_BUDGET_BENEFITS]: 'mini_quiz_budget_benefits',
  // Shared first-order checkout, reached by every arm and by visitors outside
  // the experiment entirely. Named here so `buttonClickedEvent` on this page
  // reports a page name instead of null.
  [CHECKOUT_SHIPPING_ROUTE]: 'checkout_shipping',
};
